module.exports = __webpack_public_path__ + "static/media/JP.3bfffe29.png";